import { decode } from "he";

export const decodeHtmlEntities = (text: string): string => {
  if (!text || typeof text !== "string") {
    return text;
  }

  try {
    return decode(text);
  } catch (error) {
    return text;
  }
};
